import { Link as RouterLink } from 'react-router-dom';
import { routeActive } from '@utils/routes';
import { useStyles } from './styles/MainBarHeader.styles';
import { checkPathHasPermission } from '@utils/permissions';
import { useSelector } from 'react-redux';

import type { RouteItem } from '@/types/routes';
import type { RootState } from '@features/redux/store';

interface FlatRouteProps {
    mobile: boolean;
    route: RouteItem;
    onClick?: () => void;
}

export const FlatRoute = ({ mobile, route, onClick }: FlatRouteProps) => {
    const classes = useStyles();
    const role = useSelector((state: RootState) => state.auth.Roles.role);

    return checkPathHasPermission(role, route.link) ? (
        <li key={route.label} className={classes.headerItemWrapper}>
            <RouterLink
                className={routeActive(route) ? classes.headerItemActive : classes.headerItem}
                to={route.link}
                onClick={onClick}>
                {routeActive(route) ? route.IconActive : route.Icon}
                {route.label}
            </RouterLink>
        </li>
    ) : null;
};
